export default {
  props: {
    tag: Object,
  },

  methods: {
    deleteFilter: function(key, value){
      this.$store.dispatch('removeTag',{key, value}).then(() => {})
    },
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/TagItemMix.js
// module id = null
// module chunks = 